<template>
  <div class="container">
    <breadcrumbs></breadcrumbs>
    <title-block :title="zoneName" :callback="GetOrRefreshData"></title-block>
    <div class="buttons are-medium">
      <a
        v-if="selectedZone"
        class="button"
        @click="selectedZone.drawingUri == null ? null : downloadDrawing()"
        :disabled="selectedZone.drawingUri == null"
        >Download Tekening</a
      >
      <b-upload v-model="file" @input="onFileChange">
        <a class="button">Upload Tekening</a>
      </b-upload>
    </div>
    <div class="level" style="margin-bottom: 6px">
      <div class="level-left">
        <h5 class="title is-5">
          {{ 'Openingen in ' + zoneName }}
        </h5>
      </div>
      <b-select v-model="perPage" class="is-size-7 float-right">
        <option value="5">5 per pagina</option>
        <option value="10">10 per pagina</option>
        <option value="15">15 per pagina</option>
        <option value="20">20 per pagina</option>
        <option value="0">alles</option>
      </b-select>
    </div>
    <b-table
      v-if="selectedZone"
      :data="selectedZone.openings"
      default-sort-direction="asc"
      :loading="isLoading"
      hoverable
      narrowed
      :selected.sync="selected"
      :paginated="perPage > 0"
      :per-page="perPage"
      @click="row => rowClicked(row)"
    >
      <template>
        <b-table-column cell-class="pointer" field="tagId" label="Qr-code" sortable v-slot="props">{{
          props.row.tagId
        }}</b-table-column>
        <b-table-column cell-class="pointer" field="idOnDrawing" label="Id" sortable v-slot="props">{{
          props.row.idOnDrawing
        }}</b-table-column>
        <b-table-column cell-class="pointer" field="room" label="Kamer" sortable v-slot="props">{{
          props.row.room
        }}</b-table-column>
        <b-table-column cell-class="pointer" field="fireRating" label="Eis" sortable v-slot="props">{{
          props.row.fireRating
        }}</b-table-column>
        <b-table-column
          cell-class="pointer"
          field="nrPenetrants"
          label="Aantal Doorvoeringen"
          sortable
          v-slot="props"
          >{{ props.row.penetrants.length }}</b-table-column
        >
        <b-table-column cell-class="pointer" field="comment" label="Opmerking" sortable v-slot="props">{{
          props.row.comment
        }}</b-table-column>
        <!-- <b-table-column field="dbDate" label="Datum" sortable>{{
          new Date(props.row.dbDate).toLocaleDateString('nl-NL')
        }}</b-table-column> -->
        <b-table-column cell-class="pointer" field="captureTime" label="Datum" sortable v-slot="props">{{
          props.row.captureTime
            ? new Date(props.row.captureTime).toLocaleDateString('nl-NL')
            : new Date(props.row.dbDate).toLocaleDateString('nl-NL')
        }}</b-table-column>
        <b-table-column cell-class="pointer" field="status" label="Status" sortable v-slot="props">{{
          props.row.status | status
        }}</b-table-column>
      </template>
      <template slot="bottom-left" v-if="admin">
        <span style="padding-left: 20px">
          <button class="button is-primary" @click="showModalNew = true">
            <span class="icon is-small">
              <i class="fas fa-plus"></i>
            </span>
            <span> Voeg Opening Toe </span>
          </button>
        </span>
      </template>
    </b-table>
    <b-modal
      :active.sync="showModal"
      :aria-modal="true"
      aria-role="dialog"
      :trap-focus="true"
      :width="960"
      :can-cancel="['x']"
    >
      <opening-modal :admin="admin" @created="GetOrRefreshData()"></opening-modal>
    </b-modal>
    <b-modal
      :active.sync="showModalNew"
      :aria-modal="true"
      aria-role="dialog"
      :trap-focus="true"
      :width="960"
      :can-cancel="['x']"
    >
      <opening-modal :admin="admin" :newOpening="true" @created="createdMethod"></opening-modal>
    </b-modal>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/General/Breadcrumbs'
import TitleBlock from '@/components/General/TitleBlock'
import OpeningModal from '@/components/Projects/OpeningModal'
import { mapGetters } from 'vuex'
import OpeningService from '@/services/openingService'
import axios from 'axios'
import projectService from '../../services/projectService'

export default {
  components: {
    Breadcrumbs,
    TitleBlock,
    OpeningModal
  },

  filters: {
    status: function (value) {
      if (!value) return ''
      let res = ''

      switch (value) {
        case 0:
          //none
          res = 'Geen'
          break
        case 1:
          //quote
          res = 'Offerteopname: geen QR'
          break
        case 2:
          //preliminaryPending
          res = 'Vooropname: niet akkoord'
          break
        case 3:
          //preliminaryReady
          res = 'Vooropname: akkoord'
          break
        case 4:
          //assemblyPending
          res = 'Montage: niet akkoord'
          break
        case 5:
          //assemblyReady
          res = 'Montage: akkoord'
          break
        case 6:
          //postAssemblyInspectionAccepted
          res = 'Inspectie: akkoord'
          break
        case 7:
          //externalInspectionAccepted
          res = 'Inspectie: niet akkoord'
          break
        case 8:
          //periodicalInspectionAccepted
          res = 'Inspectie periodiek: akkoord'
          break
        case 9:
          //mutation
          res = 'Mutatie: reparatie/herstel'
          break
        case 10:
          //report
          res = 'Meld: niet akkoord'
          break
        default:
          break
      }
      return res
    }
  },

  data() {
    return {
      perPage: 15,
      zonesOverview: [],
      selected: null,
      zoneInfo: null,
      file: null,
      dataURL: null,
      showModalNew: false,
      admin: false
    }
  },

  computed: {
    ...mapGetters(['project', 'selectedZone', 'isLoading', 'showOpeningModal', 'user', 'adminClaim']),
    zoneId() {
      return this.$route.params.zoneId
    },
    buildingId() {
      return this.$route.params.buildingId
    },
    projectId() {
      return this.$route.params.projectId
    },
    showModal: {
      get() {
        return this.showOpeningModal
      },
      set() {
        this.$store.commit('SHOW_OPENING_MODAL', false)
      }
    },
    zoneName() {
      if (!this.selectedZone || !this.selectedZone.name) return ''

      const firstFive = this.selectedZone.name.substring(0, 5).toUpperCase()

      if (firstFive == 'ZONE ') return this.selectedZone.name

      return `Zone ${this.selectedZone.name}`
    }
  },
  watch: {
    dataURL: async function (val) {
      this.zoneInfo.Drawing = val
      if (this.file.type.includes('image/')) {
        this.zoneInfo.DrawingFileExtension = this.file.type.replace('image/', '.')
      } else if (this.file.type.includes('application/')) {
        this.zoneInfo.DrawingFileExtension = this.file.type.replace('application/', '.')
      } else {
        console.error('The uploaded drawing is not an image or a pdf')
      }
      await OpeningService.updateZone(this.project.projectId, this.zoneId, this.zoneInfo)
      this.GetOrRefreshData()
    }
  },
  async mounted() {
    this.checkAdmin()
    console.log('%cMounted and Loading Data', 'color:yellow;')
    if (this.$store.getters.project.projectId != this.projectId) {
      const resProject = await projectService.getProject(this.projectId)
      await this.$store.dispatch('setProject', resProject.data)
      const resZone = await projectService.getZone(this.projectId, this.zoneId)
      this.$store.commit('SET_SELECTED_ZONE', resZone.data)
      const building =
        this.project.buildings[
          this.project.buildings.findIndex(e => {
            return e.buildingId == this.buildingId
          })
        ]
      this.$store.commit('SET_SELECTED_BUILDING', building)
      const story =
        building.stories[
          building.stories.findIndex(e => {
            return e.storyId == resZone.data.storyId
          })
        ]
      this.$store.commit('SET_SELECTED_FLOOR', story)
      this.GetOrRefreshData()
    }
    if (!this.selectedZone) {
    }

    const defaultAmountOfRows = 15
    const rows = localStorage.getItem('pagedTableRows')
    this.perPage = rows || defaultAmountOfRows

    if (!this.selectedZone.openingsDetailsDataFetched) {
      this.GetOrRefreshData()
    }
  },
  beforeDestroy() {
    localStorage.setItem('pagedTableRows', this.perPage)
  },

  methods: {
    async GetOrRefreshData() {
      this.$store.commit('ISLOADING', true)
      const resZone = await projectService.getZone(this.project.projectId, this.zoneId)
      this.$store.commit('SET_SELECTED_ZONE', resZone.data)
      console.log(resZone)
      this.selectedZone.openingsDetailsDataFetched = true

      await OpeningService.getOpeningsForZone(this.project.projectId, this.zoneId)
        .then(res => {
          this.$store.commit('SET_OPENINGS_FOR_SELECTED_ZONE', res.data.openings)
          this.$store.commit('ISLOADING', false)
        })
        .catch(err => {
          this.$store.commit('ISLOADING', false)
        })
      await OpeningService.readZone(this.project.projectId, this.zoneId).then(res => {
        this.zoneInfo = res.data
      })
      this.$store.dispatch('updateCrumbs', { name: 'ZoneOverview' })
    },
    async createdMethod(data) {
      this.showModalNew = false
      await this.GetOrRefreshData()
      this.$store.commit('SET_SELECTED_OPENING', data)
    },
    rowClicked(row) {
      this.$store.commit('SET_SELECTED_OPENING', row)
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.zoneName + '_Drawing.pdf') //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    async downloadDrawing() {
      const res = await OpeningService.readZone(this.project.projectId, this.zoneId)
      window.open(res.data.drawingUri, '_blank')
    },
    onFileChange: async function (event) {
      const reader = new FileReader()
      const vm = this
      reader.onload = e => {
        vm.dataURL = e.target.result.split(',')[1]
        //vm.DrawingFileExtension = e
      }
      reader.readAsDataURL(this.file)
    },
    async checkAdmin() {
      let bool = false
      bool = await this.$store.dispatch('getProjectAdminClaim', this.projectId)
      this.admin = bool
    }
  }
}
</script>

<style lang="scss" scoped>
td {
  cursor: pointer;
}
.fixedwidth {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/ZoneOverview.vue